import { mutatorAction } from 'satcheljs';
import { NotificationSettingValue } from '../utils/Constants';
import { getNotificationSettingsStore } from '../store/store';
import { ObservableMap } from 'mobx';

export const setNotificationSettings = mutatorAction(
    'SET_NOTIFICATION_SETTING',
    (desktopNotificationSettings: ObservableMap<string, NotificationSettingValue>) => {
        getNotificationSettingsStore().settings = desktopNotificationSettings;
    }
);
